import { Select, Space } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
//import { useSelector } from "react-redux";
import trans from "../../../utils";

import { popupcontext } from "../../../context/Popupscontext";

import { useGetChildUsersQuery } from "../../../Redux/service/Users/Users";
import { useGetAllUsersQuery } from "../../../Redux/service/Users/Users";

export default function UsersMultiInput({
	label,
	styling,
	handleLink,
	handleUnLink,
	vehicleId,
	userId,
	type,
}) {
	const { isLinking, reloadData } = useContext(popupcontext);
	const [mergedData, setMergedData] = useState([]);
	const [isOpen, setIsOpen] = useState(false);
	const [selectedUsers, setSelectedUsers] = useState([]);
	const [groups, setGroups] = useState([]);
	let { data: AllUsers, refetch: AllUsersReftech } = useGetAllUsersQuery(
		{
			page: 1,
			limit: 10000,
		},
		{ refetchOnMountOrArgChange: true },
	);
	let { data: UserunderUsers, refetch: UserunderUsersRefetch } =
		useGetChildUsersQuery(
			{ userId },
			{
				skip: !userId,
				refetchOnMountOrArgChange: true,
			},
		);
	const handleDropdownVisibleChange = (visible) => {
		if (visible) {
			setIsOpen(true);
		} else {
			setIsOpen(false);
		}
	};
	console.log("AllUsers", AllUsers);
	console.log("UserunderUsers", UserunderUsers);
	useEffect(() => {
		if (AllUsers && UserunderUsers) {
			const merged = [...AllUsers?.data, ...UserunderUsers?.data];
			console.log("merged", merged);
			const unique = merged.filter(
				(item, index, self) =>
					index === self.findIndex((t) => t.id === item.id),
			);
			setMergedData(unique);
		}
	}, [AllUsers, UserunderUsers]);

	useEffect(() => {
		setGroups(
			mergedData?.map((i) => ({
				value: i.id,
				label: i.name,
			})),
		);
	}, [mergedData]);

	useEffect(() => {
		if (type === "users" && UserunderUsers?.data?.length > 0) {
			setSelectedUsers(UserunderUsers.data.map((i) => i.id));
		}
	}, [UserunderUsers?.data, type]);

	useEffect(() => {
		if (isLinking && type === "users" && reloadData) {
			UserunderUsersRefetch();
		}
	}, [isLinking, type, reloadData]);
	console.log("mergedData", mergedData);
	return (
		<div className={styling}>
			{label && <div className="mult-input-label">{trans(label)}</div>}
			<Space
				style={{
					width: "100%",
					borderColor: "red",
				}}
				direction="vertical"
			>
				<Select
					mode="multiple"
					style={{
						width: "100%",
						marginTop: "8px",
						borderColor: "red",
					}}
					maxTagCount={"responsive"}
					placeholder={trans("Please select")}
					onSelect={(value) => {
						setSelectedUsers((prev) => [...prev, value]);
						handleLink(value, "managedUser", "User", "User");
					}}
					onDeselect={(value) => {
						setSelectedUsers((prev) => prev.filter((v) => v !== value));
						handleUnLink(value, "managedUser", "User", "User");
					}}
					value={mergedData?.length > 0 ? selectedUsers : undefined}
					options={groups}
					open={isOpen}
					onDropdownVisibleChange={handleDropdownVisibleChange}
					filterOption={(input, option) =>
						option.label.toLowerCase().includes(input.toLowerCase())
					}
				/>
			</Space>
		</div>
	);
}
